import React, { Component } from 'react';
import {connect} from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';

import { addItemByCommunity, updItem, getAllItemsIcons } from '../../actions/itemAction';

import ItemIconsModal from './ItemIconsModal';

import { Button, Card, CardActions, Checkbox, Grid, Modal, Paper } from '@material-ui/core';
import { renderLegacyTextField, renderSwitchWithLabelV4 } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import { sweetAlert } from '../../components/Alert/sweetAlert';

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The item must have less than ${props.characterLimit} characters`;
    }

    if (!values.iconUrl) {
        errors.iconUrl = 'Please select an icon';
    }
    return errors;
};

class AddEditItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open : true,
            _id: props?.data?._id? props.data._id: null,
            roomsByItem: props?.data?.rooms? props.data.rooms:[],
            iconUrl: props?.data?.iconUrl?props.data.iconUrl:'https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg',
            solidIcon:'',
            openIconsModal:false,
            SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},
        };

        if (props.data) {
            this.props.dispatch(change('ItemForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('ItemForm', 'name', props.data && props.data.name));
            this.props.dispatch(change('ItemForm', 'iconUrl', props.data && props.data.iconUrl));
            this.props.dispatch(change('ItemForm', 'iconResourceName', props.data && props.data.iconResourceName));
        } else {
            this.props.dispatch(change('ItemForm', '_id', ''));
            this.props.dispatch(change('ItemForm', 'name', ''));
            this.props.dispatch(change('ItemForm', 'iconUrl', ''));
            this.props.dispatch(change('ItemForm', 'iconResourceName', ''));
        }
    }

    componentDidMount(){
        this.props.getAllItemsIcons();
    }

    handleToggle = (value) => {

        if (!this.state.roomsByItem) {
            const newChecked = [];
            newChecked.push(value);
            this.setState({ roomsByItem: newChecked })
        } else {
            const currentIndex = this.state.roomsByItem.indexOf(value);
            const newChecked = this.state.roomsByItem;

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }
            this.setState({ roomsByItem: newChecked })
        }
    };


    handleChange = (event) => {
        //setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked)
            this.setState({ roomsByItem: (this.props && this.props.rooms && this.props.rooms.length > 0) ? this.props.rooms.map(room => room._id) : [] })
        else
            this.setState({ roomsByItem: [] })
    };



    isSwitchChecked = () => {
        let isChecked = false;

        if (this.props.rooms && Array.isArray(this.props.rooms) && (typeof (this.state.roomsByItem) === 'object') && this.state.roomsByItem) {
            isChecked = !this.props.rooms.some((i) => this.state.roomsByItem.indexOf(i._id) === -1);
        }

        return isChecked;
    }

    handleSelectIcon=(icon)=>{
        this.setState({iconUrl:icon.iconUrl, solidIcon:icon.solidIconUrl, openIconsModal:false})
    }

    onSubmitHandler=(formData)=>{

        formData.rooms = this.state.roomsByItem
        formData.iconUrl = this.state.iconUrl

        if (formData.name.length > this.props.characterLimit) {
            const message = `The item must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditItem_CharacterLimit_Error', this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
            return;
        }

        if(!this.state.iconUrl || this.state.iconUrl ==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg'){
            const message = `Please select an Icon`
            sweetAlert('error', message, 'alert_AddEditItem_icon_error', this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
            return;
        }


        if (!this.state._id) {
            this.props.addItemByCommunity(formData, localStorage.getItem('communityId'), this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});

        } else {
            this.props.updItem(this.state._id, formData, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {}); 

        }

        this.setState({ roomsByItem: [] })

        this.props.close();
    }



    render() {
        const { handleSubmit } = this.props;

        return (
            <>
                <Paper elevation={3} square='false' color='secondary'>
                    <Grid id='add_item_modal' className="LItemspaperModal">
                        <form style={{height:'100%'}}>
                            <Grid item container xs={12} style={{height:'90%'}} alignItems='baseline'>
                                <Grid item xs={12} className='lmodalTitle'>{this.props.data? 'Update Item': 'New Item'}</Grid>

                                {/* Name and icon select */}
                                <Grid item container xs={12} className='LformSection sectionMargin' alignItems='center' style={{padding:'20px'}}>
                                    <Grid item container xs={6}>
                                        <Field
                                            id='rooms_add_room_name'
                                            name="name"
                                            label="Name"
                                            maxLength={20}
                                            component={renderLegacyTextField}
                                            inputLabelClass='ldefaultTextStyles'
                                            inputClass='ldefaultTextStyles'
                                        />
                                    </Grid>

                                    <Grid item container xs={12} sm={12} md={6} lg={6} >

                                        <Grid item xs={12} className='ldefaultTextStyles' style={{fontSize:'20px', textAlign:'center', marginBottom:'10px'}}>
                                            Icon
                                        </Grid>

                                        <Grid item container xs={12}>
                                            <Grid item container xs={12} justifyContent='center'>
                                                <img
                                                    src={this.state.iconUrl}
                                                    alt='icon'
                                                    width='100px'
                                                    height='100px'
                                                    style={{opacity:(this.state.iconUrl==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg')?'56%':'100%'}}
                                                    className='Llogo-black'
                                                />
                                            </Grid>

                                            <Grid item container xs={12} justifyContent='center' style={{marginTop:'1rem'}}>
                                                <Button id='Select_Icon_Btn' item className="Lsetup_btn" onClick={()=>this.setState({openIconsModal:true})}>
                                                    Select Icon
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                   
                                </Grid>

                                {/* List of rooms */}
                                <Grid item container xs={12} className='LformSection sectionMargin roomslistcontainer'>
                                    <Grid item container >
                                        <Grid item xs={12}>
                                            <p className='ldefaultTextStyles' style={{fontSize:'20px', textAlign:'center', marginBottom:'10px'}}>Rooms list</p>
                                            <div style={{ textAlign: 'left' }}>
                                                <Grid item xs={6} md={4} lg={2} style={{ padding: '10px', paddingTop: '40px' }}>
                                                    <Field
                                                        name="selectAll"
                                                        label="Select All"
                                                        checked={this.isSwitchChecked()}
                                                        onClick={this.handleChange}
                                                        component={renderSwitchWithLabelV4}
                                                        stylesLabel={{fontSize:'18px', fontFamily:'Gotham-Book', color:'black'}}
                                                        idToSet='selectAlltoogle'
                                                        id='selectAlltoogle'

                                                    />
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item container>
                                        {
                                            this.props.rooms && Array.isArray(this.props.rooms) && this.props.rooms.map((itemRoom, index) => {

                                                return (

                                                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ padding: '4px' }} key={index}>
                                                        <Card key={index} className="lcardElement" id={`items_room_card_${itemRoom._id}`} >
                                                            <CardActions className="CardActions">
                                                                <Grid item container xs={12} alignContent='center' style={{ height: '100%', overflow: 'hidden' }}>
                                                                    <Grid item container xs={4} md={3} lg={2}  justifyContent='center' alignContent='center' className='CheckboxBlue RepairsCell'>
                                                                        <Checkbox
                                                                            id={`checkbox_${itemRoom._id}`}
                                                                            checked={this.state.roomsByItem ? this.state.roomsByItem.indexOf(itemRoom._id) !== -1 : false}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={() => this.handleToggle(itemRoom._id)}
                                                                            icon={<CheckBoxOutlineBlank fontSize="large" style={{color:'black'}} />}
                                                                            checkedIcon={
                                                                                <CheckBox fontSize="large"  style={{color:'#009EDD'}} />
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    <Grid item container xs={8} md={9} lg={10} alignContent='center' className='WrapText lengage_Title' style={{ overflow: 'hidden' }}>
                                                                        {
                                                                            itemRoom.name
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </CardActions>
                                                        </Card>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                
                                </Grid>
                               

                            </Grid>

                              {/* Buttons section */}
                            <Grid item container justifyContent='space-evenly' xs={12} alignItems='center' style={{height:'10%'}}>
                                <Button id='cancel_btn' item container className="lcancelBtn" onClick={()=>this.props.close()}>
                                    Cancel
                                </Button>
                 
                                <Button id='save_btn' item container className="Lsetup_btn" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </Button>

                            </Grid>
                        </form>


                    
                    </Grid>
               
                </Paper>

                <Modal
                    open={this.state.openIconsModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ borderRadius: '16px' }}
                    onClose={() => this.setState({openIconsModal:false})}
                >

                    <ItemIconsModal
                        onDone={this.handleSelectIcon}
                        onCancel={()=>this.setState({openIconsModal:false})}
                    />

                </Modal>
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    const rooms = state.roomReducer && state.roomReducer.roomData && Array.isArray(state.roomReducer.roomData) ? state.roomReducer.roomData : [];
    const itemsIconsData = state.itemReducer && state.itemReducer.itemsIconsData && state.itemReducer.itemsIconsData.icons ? state.itemReducer.itemsIconsData.icons : [];


    return{

        rooms,
        itemsIconsData
    }
};

export default connect(mapStateToProps, {addItemByCommunity, updItem, getAllItemsIcons})(reduxForm({
    form: 'ItemForm',
    validate,
    enableReinitialize: true,
})(AddEditItem));

